import { useCallback } from 'react';

import { MarqueDto, ModeleDto } from 'lib_api/lib/api/gen';

import { BaseOptionType } from 'components/BaseForm/Select/BaseSelect';
import { useApi } from 'hooks/ApiStoreContext';
import { fetchModeleByMarqueIdCorrelation } from 'search/searchModeleByMarqueIdCorrelation';
import { VALUE_NON_REFERENCE } from 'utils/global';

export const useFetchModeleByMarqueIdCorrelation = (): [
  (marque: BaseOptionType<MarqueDto> | null) => Promise<Array<ModeleDto>>,
] => {
  const { ReferentielControllerApi: refController } = useApi();

  const fetch = useCallback((marque: BaseOptionType<MarqueDto> | null) => {
    if (!marque?.option?.id || marque.value === VALUE_NON_REFERENCE) {
      return Promise.resolve([]);
    }

    return fetchModeleByMarqueIdCorrelation(
      refController,
      marque.option?.idCorrelation || '',
    );
  }, []);

  return [fetch];
};
